<template>
  <label
    v-if="sort && sortOptions?.length && sortOptions.length > 1"
    class="sort-links"
    :class="{
      'sort-links--start': arrivedState.left,
      'sort-links--end': arrivedState.right,
    }"
  >
    <span
      class="sort-links__label"
    >{{ $t('Sort by') }}</span>

    <div
      class="sort-links__container"
    >
      <ul
        ref="sortLinks"
        class="sort-links__list"
      >
        <li
          v-for="option in sortOptions"
          :key="`sort-${option.key}`"
          class="sort-links__item"
        >
          <button
            class="button button--secondary"
            :class="{
              'sort-links__button--active': option.key === sort,
            }"
            @click="(event) => $emit('updateSort', option.key)"
          >
            {{ $t(option.label) }}
          </button>
        </li>
      </ul>
    </div>
  </label>
</template>

<script setup lang="ts">
defineProps<{
  sort: string
  sortOptions: any[]
}>()

defineEmits(['updateSort'])

const sortLinks = ref<HTMLElement | null>(null)
const { arrivedState } = useScroll(sortLinks)
</script>

<style src="~layers/app/components/Paginator/SortLinks.css" />
